<template>
  <router-view />
</template>
<script>
export default {
  name: 'Magnum',
};
</script>
